// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SeatListRow__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AirlineSeatSelection/SeatListRow.scss
 ** module id = 880
 ** module chunks = 1
 **/